import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Bookmark = createReactComponent("Bookmark", ["svg", defaultAttributes, [["path", {
  d: "M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z",
  key: "qip9cr"
}]]]);
export default Bookmark;